<template>
	<div>
		<claim-detail-submenu />

		<core-layout-content full>
			<core-layout-headline-and-actions>
				<template slot="headline">
					{{ $t("logs") }}
				</template>
			</core-layout-headline-and-actions>

			<!-- Data Container -->
			<j-card class="bg5">
				<j-data-table
					:header="header"
					:list="computedLogs"
					:sortable="false"
					:isLoading="isLoading"
					@sort="onSort($event)"
				>
					<template slot="list" slot-scope="{ item }">
						<td v-for="(column, i) in header" :key="i">
							{{ item[column.field] }}
						</td>
					</template>
					<template slot="empty">
						{{ $t("errors.no_data") }}
					</template>
				</j-data-table>
			</j-card>
		</core-layout-content>
	</div>
</template>

<script>
import CrmIcon from "@/components/CrmIcon/"
import JButton from "@/components/JButton/"
import JCard from "@/components/JCard/"
import JDataTable from "@/components/JDataTable/"
import JBaseInputSearch from "@/components/JBaseInputSearch/"
import JPagination from "@/components/JPagination/"
import CorePaginationInfo from "@/modules/core/components/CorePaginationInfo"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions"
import ClaimDetailSubmenu from "../components/ClaimDetailSubmenu"
import dayjs from "dayjs"
import api from "../api/"
import get from "lodash.get"

export default {
	components: {
		CrmIcon,
		JButton,
		JCard,
		JDataTable,
		JBaseInputSearch,
		JPagination,
		CorePaginationInfo,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		ClaimDetailSubmenu
	},

	props: {
		// From router
		id: String
	},

	data: () => ({
		isLoading: false,
		logs: []
	}),

	computed: {
		header() {
			return [
				{ text: this.$t("when"), field: "when", sortable: false },
				{ text: this.$t("user"), field: "user", sortable: false },
				{ text: this.$t("event"), field: "event", sortable: false }
			]
		},

		computedLogs() {
			const events = this.logs
			if (!events) return []

			// Crunch events
			// Also reverse them so that most recent one is the most top
			return events
				.map(item => ({
					when: item.timestamp
						? dayjs(item.timestamp).format(
								this.$store.state.settings.dateTimeFormat
						  )
						: null,
					user: get(item, "by.username"),
					event: this.$t(`logs_enums.${item.type}`)
				}))
				.reverse()
		}
	},

	methods: {
		async fetchLogs() {
			this.isLoading = true
			const res = await api.claimLogs({ where: { id: this.id } })
			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			// Success
			this.logs = get(res, "data.claims.list[0].events")
		}
	},

	created() {
		this.fetchLogs()
	}
}
</script>
